<h1 class="text-center m-0">Nouvelle mesure </h1>
<div class="p-3 pt-0">
    <div class="col">
        <div class="">
            <div class="row justify-content-center mb-1">
                <div class="col-auto">
                    <mat-checkbox [(ngModel)]="NewMeasure.IsForEauIntegre" [disabled]="HasOnlyIntegratedWater">Pour eau Integrée ?</mat-checkbox>
                </div>
            </div>
            <div class="row" *ngIf="!NewMeasure.IsForEauIntegre">
                <mat-form-field class="col">
                    <mat-label>Profondeur (m)</mat-label>
                    <input matInput placeholder="Profondeur (m)" type="number" [(ngModel)]="NewMeasure.Profondeur" [formControl]="ValidProfMax">
                    <mat-error *ngIf="ValidProfMax.hasError('max') || ValidProfMax.hasError('min')">
                        0 à {{PROF_MAX}}m
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col">
                    <mat-label>Temp Brute</mat-label>
                    <input matInput placeholder="Température Brute" type="number" [(ngModel)]="NewMeasure.TemperatureBrute" [formControl]="ValidTempMax">
                    <mat-error *ngIf="ValidTempMax.hasError('max') || ValidTempMax.hasError('min')">
                        0 à {{TEMP_MAX}}°C
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>pH</mat-label>
                    <input matInput placeholder="pH" type="number" [(ngModel)]="NewMeasure.pH" [formControl]="ValidPhMax">
                    <mat-error *ngIf="ValidPhMax.hasError('max') || ValidPhMax.hasError('min')">
                        0 à {{PH_MAX}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col">
                    <mat-label>Conductivité</mat-label>
                    <input matInput placeholder="Conductivité" type="number" [(ngModel)]="NewMeasure.Conductivite">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Oxygène Dissous</mat-label>
                    <input matInput placeholder="Oxygène Dissous" type="number" [(ngModel)]="NewMeasure.OxygeneDissous" [formControl]="ValidOxygeneMax">
                    <mat-error *ngIf="ValidOxygeneMax.hasError('max') || ValidOxygeneMax.hasError('min')">
                        0 à {{OXY_MAX}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Saturation O2d</mat-label>
                    <input matInput placeholder="Saturation O2d" type="number" [(ngModel)]="NewMeasure.SaturationO2d" [formControl]="ValidSaturationMax">
                    <mat-error *ngIf="ValidSaturationMax.hasError('max') || ValidSaturationMax.hasError('min')">
                        0 à {{SAT_MAX}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                    Annuler<mat-icon>undo</mat-icon>
                </button>
            </div>
            <div class="row">
                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                    Enregistrer<mat-icon>save</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>